package com.essntl.core.whatsapp.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class WhapiGroupTemplate(
    val subject: String,
    val participants: List<String>
)
